import { Link } from "react-router-dom";
import type { VideoItem } from "@/types/video";
import { formatRating, formatViews, typeLabel } from "@/lib/format";

interface VideoCardProps {
  video: VideoItem;
}

export default function VideoCard({ video }: VideoCardProps) {
  return (
    <Link
      to={`/detail/${video.id}`}
      className="group block cursor-pointer overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-primary-300"
    >
      <div className="relative aspect-[2/3] w-full overflow-hidden bg-background-200">
        <img
          src={video.cover}
          alt={`${video.title} 封面海报`}
          title={`${video.title} 在线观看`}
          className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute left-2 top-2 rounded-md bg-secondary-900/80 px-2 py-0.5 text-xs font-medium text-background-50">
          {typeLabel(video.type)}
        </span>
        <span className="absolute right-2 top-2 rounded-md bg-accent-500/95 px-2 py-0.5 text-xs font-semibold text-background-50">
          {formatRating(video.rating)}
        </span>
        <div className="absolute inset-x-0 bottom-0 flex items-center gap-1 bg-gradient-to-t from-black/70 to-transparent px-2 pb-2 pt-8 text-xs text-background-50">
          <i className="ri-play-circle-line" />
          <span>{formatViews(video.views)}</span>
        </div>
      </div>
      <div className="p-3">
        <h3 className="truncate font-heading text-sm font-semibold text-foreground-950 group-hover:text-primary-600">
          {video.title}
        </h3>
        <p className="mt-1.5 truncate text-xs text-foreground-600">
          {video.year} · {video.region} · {video.episodes}
        </p>
      </div>
    </Link>
  );
}